import React from "react";
import classes from "./SectorsGrid.module.scss";
import SectorCard from "./SectorCard.tsx";

export interface ISectorCard {
  image: string;
  title: string;
  text: string;
  id?: number;
}

const SectorsGrid: React.FC<{
  cards: ISectorCard[];
  title: string;
  subtitle?: string;
}> = ({ cards, title, subtitle = "" }) => {
  return (
    <div className={classes["container"]}>
      <div className={classes["text-container"]}>
        <h2 className={classes["title"]}>{title}</h2>
        {subtitle && <p className={classes.subtitle}>{subtitle}</p>}
      </div>
      <div className={`${classes["cards-container"]}`}>
        {cards.map(({ image, title, text, id }) => (
          <SectorCard
            key={id}
            image={image}
            title={title}
            text={text}
            smallCards={true}
          />
        ))}
      </div>
    </div>
  );
};

export default SectorsGrid;
